import {
  BREADCRUMB_LIST_APP_CLASS,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import type { OrderStatus } from './order-status-config';
import { OrderStatusControl } from './OrderStatusControl';
import { FrontEmailLink } from './FrontEmailLink';
import { useTranslation } from '@hooks/useTranslation';

interface OrderDetailsHeaderProps {
  orderId: number;
  orderNumber: string;
  status: OrderStatus;
  frontConversationId?: string | null;
}

export function OrderDetailsHeader({ orderId, orderNumber, status, frontConversationId }: OrderDetailsHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        <Breadcrumb>
          <BreadcrumbList className={BREADCRUMB_LIST_APP_CLASS}>
            <BreadcrumbItem>
              <BreadcrumbLink href="/orders">{t('header.breadcrumb_orders')}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{orderNumber}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <FrontEmailLink conversationId={frontConversationId} />
      </div>

      <OrderStatusControl orderId={orderId} status={status} />
    </div>
  );
}
